<template>
    <div class="d-flex flex-wrap gap-3">
        <v-card class="cts-pane p-5">
                <div class="mb-5">
                    <v-label>{{ $t('ResourceSource')}} </v-label>
                    <div class="mb-4">
                        <multi-select class="light-bg add-arrow" label="name" v-model="selected_scanner_item"
                            track-by="index" open-direction="bottom" :options="scanner_items"
                            :searchable="true" :internal-search="false" :clear-on-select="false"
                            :close-on-select="true" :options-limit="300" :max-height="600"
                            :show-no-results="false" :hide-selected="false" :multiple="false">
                        </multi-select>
                    </div>
                </div>
                <div class="d-flex mb-5" style="gap: 18px">
                    <label>
                        <v-checkbox v-model="showUI" :label="$t('ResourceShowUI')"></v-checkbox>
                    </label>
                    <label>
                        <v-checkbox v-model="ADF" :label="$t('ResourceADF')"></v-checkbox>
                    </label>
                    <label>
                        <v-checkbox v-model="Duplex" :label="$t('ResourceDuplex')"></v-checkbox>
                    </label>
                </div>
                <div class="mb-5">
                    <v-label>{{ $t('ResourcePixelType')}} </v-label>
                    <multi-select class="light-bg" label="name" v-model="selected_pixel_type"
                        track-by="index" open-direction="bottom" :options="pixel_type_items"
                        :searchable="true" :internal-search="false" :clear-on-select="false"
                        :close-on-select="true" :options-limit="300" :max-height="600"
                        :show-no-results="false" :hide-selected="false" :multiple="false">
                    </multi-select>
                </div>
                <div class="mb-5">
                    <v-label>{{ $t('ResourceResolution')}} </v-label>
                    <multi-select class="light-bg" label="name" v-model="selected_resolution"
                        track-by="value" open-direction="bottom" :options="resolution_items"
                        :searchable="true" :internal-search="false" :clear-on-select="false"
                        :close-on-select="true" :options-limit="300" :max-height="600"
                        :show-no-results="false" :hide-selected="false" :multiple="false">
                    </multi-select>
                </div>
                <div class="d-flex py-5 px-1" style="gap: 32px; border-top: 1px solid #E7EBEF;">
                    <v-btn class="btn-text text-primary weight-500" @click="scanFile()"><v-icon
                            class="custom-icon">mdi-scan</v-icon>{{ $t('ResourceScanFile') }}</v-btn>

                    <v-btn class="btn-text text-primary weight-500" @click="GetImageData()"><v-icon
                            class="custom-icon">mdi-upload</v-icon>{{ $t('ResourceUploadFile') }}</v-btn>
                </div>
        </v-card>
        <div class="cts-pane pb-0" style="background: #e7ebef; flex-grow: 2;">
            <!--viewer section-->
            <div class=" h-100 position-relative viewer-container">
                <div class="ContentWithoutToolbarAndPadding MiddleSection">
                    <div id="dwtcontrolContainer" class="ds-dwt-container noPadding">
                    </div>
                    <div id="DWTNonInstallContainerID"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import MultiSelect from 'vue-multiselect'
    import axios from "axios"
    import constants from "@/assets/js/constants.js"

    export default{
        name: 'DeliveryNotes',
        components: { MultiSelect },
        props: {
            documentId: { type: [String, Number], default: '0' },
            attachmentId: { type: Number, default: 0 },
            referenceNumber: { type: String, default: "" }
        },
        data(){
            return{
                selected_scanner_item: {},
                selected_pixel_type: { name: 'RGB', index: 2 },
                selected_resolution: { name: '300', value: '300' },
                scanner_items: [],
                pixel_type_items: [
                    { name: 'BW', index: 0 },
                    { name: 'Gray', index: 1 },
                    { name: 'RGB', index: 2 }
                ],
                resolution_items: [
                    { name: '100', value: '100' },
                    { name: '150', value: '150' },
                    { name: '200', value: '200' },
                    { name: '300', value: '300' },
                ],
                showUI: false,
                ADF: false,
                Duplex: false,
            }
        },
        mounted ()
        {
            this.loadScript('/resources/scan2/includes/js/scan.js', () =>{
                this.loadScript('/resources/scan2/resources/dynamsoft.webtwain.config.js', () =>{
                    Dynamsoft.WebTwainEnv.ResourcesPath = '/resources/scan2/resources/';
                    this.loadScript('/resources/scan2/resources/dynamsoft.webtwain.initiate.js', () =>{
                    });
                });
            });
        },
        watch:
        {
            documentId: function(){
                reloadDWT();
            }
        },
        methods: 
        {
            loadScript(src, callback) {
                const script = document.createElement('script');
                script.src = src;
                script.onload = callback;
                document.body.appendChild(script);
            },
            scanFile(){
                acquireImage();
            },
            GetImageData(){
                var imageData = getImageData();
                this.$emit('GetImageData', imageData)
            }
        }
    }
</script>

<style scoped>

</style>